import React, { useContext, useEffect, useRef, useState } from "react";
import "./styles";
import { PagamentoMercadoPagoContainer } from "../PagamentoMercadoPago/styles";
import { Input } from "../../Input";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { CatalogoContext } from "../../../contexts/Catalogo/CatalogoContext";
import { mercadoPagoApi } from "../../../hooks/mercadoPagoApi";
import { deepCopy } from "../../../services/Functions";
import { currencyMask, percentageMask } from "../../../services/Masks";
import { unmaskPercentage, unmaskToNumbers } from "../../../services/Unmasks";
import Modal from "../../Modal/Modal";
import { ModalContainer } from "../IntegracaoBlingV2/styles";
import { Button } from "../../Button";
import Dropdown from "../../Dropdowns/Dropdown";
import { Select } from "../../Select";
import { Toggle } from "../../Toggle/Toggle";
import { ToggleConfigurar } from "../../Toggle/ToggleConfigurar/ToggleConfigurar";
import Configuracoes from "../../../types/Configuracoes";
import {EmpresaContext} from "../../../contexts/Empresa/EmpresaContext";

interface PagamentoMercadoPagoProps {
  configIn: "empresa" | "configuracoes" | "catalogo";
  somenteLeitura?: boolean; // Dropshipping: mostra a config da mãe, sem verificar a conexão
}

const PagamentoMercadoPago: React.FC<PagamentoMercadoPagoProps> = ({ configIn, somenteLeitura }) => {
const configsEmpresa = useContext(ConfiguracoesContext);
const configsCatalogo = useContext(CatalogoContext);
const { theme } = useTheme();
const mercadoPago = mercadoPagoApi();

const [autenticado, setAutenticado] = useState(false);
const [modal, setModal] = useState(false);
const [configsCartao, setConfigsCartao] = useState(false);
const [configsPix, setConfigsPix] = useState(false);

const configuracoes =
configIn === "catalogo"
    ? configsCatalogo.catalogo
    : configsEmpresa.configuracoes;
const setConfiguracoes =
configIn === "catalogo"
    ? configsCatalogo.setCatalogo
    : configsEmpresa.setConfiguracoes;

const ignoreValidation =
somenteLeitura ||
(configIn === "catalogo"
    ? false
    : !(configuracoes as Configuracoes).mercadoPagoAtivo);

const {empresa} = useContext(EmpresaContext);
const nomeUsuario = empresa?.usuario;

const parcelas = [
    { value: 1, name: "1 parcela" },
    { value: 2, name: "2 parcelas" },
    { value: 3, name: "3 parcelas" },
    { value: 4, name: "4 parcelas" },
    { value: 5, name: "5 parcelas" },
    { value: 6, name: "6 parcelas" },
    { value: 7, name: "7 parcelas" },
    { value: 8, name: "8 parcelas" },
    { value: 9, name: "9 parcelas" },
    { value: 10, name: "10 parcelas" },
    { value: 11, name: "11 parcelas" },
    { value: 12, name: "12 parcelas" },
];

const verificarAutenticacao = async () => {
  const res = await mercadoPago.verificarAutenticacao();
  
  if (res.ativo) {
    setAutenticado(true);
    setModal(false);

    setConfiguracoes(
      deepCopy(configuracoes, {
        dados_mercadoPago: {
          ...res,
        },
      })
    );
  } else {
    setAutenticado(false);
    setModal(true);
  }
};

const handleVisibilityChange = async () => {
  if (document.visibilityState === "visible" && !ignoreValidation) {
    await verificarAutenticacao();
  }
};

const handleVisibilityChangeRef = useRef(() => {});

useEffect(() => {
    handleVisibilityChangeRef.current = handleVisibilityChange;

    if (!ignoreValidation) {
        verificarAutenticacao();
    }

    document.addEventListener(
      "visibilitychange",
      handleVisibilityChangeRef.current
    );

    return () => {
      document.removeEventListener(
        "visibilitychange",
        handleVisibilityChangeRef.current
      );
    };
}, [ignoreValidation]);

const handleCancelarAutenticacao = () => {
  setModal(false);
  setConfiguracoes(
    deepCopy(configuracoes, {
      intermediadores: {
        mercadopago: undefined,
      },
      mercadoPagoAtivo: false,
    })
  );
};


const abrirLogin = () => {
const isDev = window.location.href.includes("dev");
const isLocalhost = window.location.href.includes("localhost");

const baseUrl = isLocalhost || isDev
    ? "https://painel-api-dev.conectavenda.com.br"
    : "https://painel-api.conectavenda.com.br";

const url = `https://auth.mercadopago.com/authorization?client_id=5130116869055423&response_type=code&platform_id=mp&state=${nomeUsuario}&redirect_uri=${baseUrl}/mercado_pago/autenticacao`;

window.open(url, "_blank");
};

const handleCancel = () => {
    setModal(false);
};

  return (
    <>
      <PagamentoMercadoPagoContainer configIn={configIn} theme={theme}>
    {(autenticado || somenteLeitura) && (
        <>
        <div className="descricao-texto fonteTexto">
          O Mercado Pago é um intermediador de pagamento que permite oferecer uma experiência de compra completa na finalização do pedido. Com ele, seus clientes 
          podem pagar por PIX e/ou Cartão de Crédito, e você pode definir desconto no PIX, parcelamento no cartão, quantidade máxima de parcelas e valor mínimo por parcela.
        </div>

        <div className="togglesContainer">
          <div className="toggleCartao">
            <span className="cartao fonteTexto">
              Cartão de crédito
            </span>
            <ToggleConfigurar
              disabled={somenteLeitura}
              ignoreValidations={ignoreValidation}
              value={
                configuracoes.intermediadores.mercadopago?.cartao?.ativo || false
              }
              isValid={() => {
                return (
                  configuracoes.intermediadores.mercadopago?.cartao?.ativo &&
                  !configsCartao &&
                  (!configuracoes.intermediadores.mercadopago?.cartao?.quantidade_maxima_parcelas ||
                   !configuracoes.intermediadores.mercadopago?.cartao?.valor_minimo_parcela)
                    ? false
                    : true
                )
              }}
              invalidText="Preencha as configurações do cartão de crédito"
              onChange={(newValue) => {
                if (newValue) {
                  // Quando ativar, abre automaticamente as configurações
                  setConfigsCartao(true);
                } else {
                  // Quando desativar, fecha as configurações
                  setConfigsCartao(false);
                }
                setConfiguracoes(
                  deepCopy(configuracoes, {
                    intermediadores: {
                      mercadopago: {
                        ...configuracoes.intermediadores.mercadopago,
                        cartao: {
                          ...configuracoes.intermediadores.mercadopago?.cartao,
                          ativo: newValue
                        }
                      }
                    },
                  }),
                );
              }}
              onConfigurar={() => {
                setConfigsCartao(!configsCartao);
              }}
            />
          </div>
          <Dropdown active={configsCartao} className="dropdown">
          <fieldset disabled={somenteLeitura} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, ...(somenteLeitura ? { opacity: 0.6, pointerEvents: "none" } : {}) }}>
            <div className="configsCartaoContainer">
              <Select
                sizeLabel="medium"
                options={parcelas}
                value={
                  configuracoes.intermediadores.mercadopago?.cartao?.quantidade_maxima_parcelas
                }
                placeholder="6 parcelas"
                onChange={(newValue) => {
                  setConfiguracoes(
                    deepCopy(configuracoes, {
                      intermediadores: {
                        mercadopago: {
                          ...configuracoes.intermediadores.mercadopago,
                          cartao: {
                            ...configuracoes.intermediadores.mercadopago?.cartao,
                            quantidade_maxima_parcelas: newValue
                          }
                        }
                      },
                    }),
                  );
                }}
                label="Quantidade máxima de parcelas"
                required={!ignoreValidation && configuracoes.intermediadores.mercadopago?.cartao?.ativo}
              />
              <Input
                type="text"
                ignoreValidations={ignoreValidation || !configuracoes.intermediadores.mercadopago?.cartao?.ativo}
                required={true}
                value={
                  Number.parseFloat(
                    configuracoes.intermediadores.mercadopago?.cartao?.valor_minimo_parcela || "0",
                  ) > 0
                    ? Number.parseFloat(
                        configuracoes.intermediadores.mercadopago?.cartao?.valor_minimo_parcela || "0",
                      ).toFixed(0)
                    : ""
                }
                placeholder="R$ 10,00"
                mask={{
                  mask: currencyMask,
                  unmask: unmaskToNumbers,
                }}
                onChange={(newValue) => {
                  setConfiguracoes(
                    deepCopy(configuracoes, {
                      intermediadores: {
                        mercadopago: {
                          ...configuracoes.intermediadores.mercadopago,
                          cartao: {
                            ...configuracoes.intermediadores.mercadopago?.cartao,
                            valor_minimo_parcela: newValue
                          }
                        }
                      },
                    }),
                  );
                }}
                label="Valor mínimo de cada parcela"
              />
            </div>
                {Number(configuracoes.intermediadores.mercadopago?.cartao?.quantidade_maxima_parcelas) > 0 && (
                  <div className="jurosParcelasSection">
                    <span className="jurosLabel fonteTexto">Juros por parcela</span>
                    <div className="jurosParcelasGrid">
                      {Array.from(
                        { length: Number(configuracoes.intermediadores.mercadopago?.cartao?.quantidade_maxima_parcelas) },
                        (_, i) => i + 1
                      ).map((n) => (
                        <div key={n} className="jurosInputWrapper">
                          <span className="jurosPrefix fonteTexto">{n}x</span>
                          <Input
                            type="text"
                            ignoreValidations={true}
                            required={false}
                            value={configuracoes.intermediadores.mercadopago?.cartao?.juros_parcelas?.[n.toString()] ?? "0"}
                            placeholder="0%"
                            mask={{
                              mask: percentageMask,
                              unmask: unmaskPercentage,
                            }}
                            onChange={(newValue) => {
                              setConfiguracoes(
                                deepCopy(configuracoes, {
                                  intermediadores: {
                                    mercadopago: {
                                      ...configuracoes.intermediadores.mercadopago,
                                      cartao: {
                                        ...configuracoes.intermediadores.mercadopago?.cartao,
                                        juros_parcelas: {
                                          ...configuracoes.intermediadores.mercadopago?.cartao?.juros_parcelas,
                                          [n.toString()]: newValue === "" ? "0" : (Number(newValue) / 100).toFixed(2),
                                        },
                                      },
                                    },
                                  },
                                }),
                              );
                            }}
                            className="jurosInput"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}
          </fieldset>
          </Dropdown>

          <div className="togglePix">
            <span className="pix fonteTexto">
              Pix
            </span>
            <ToggleConfigurar
              disabled={somenteLeitura}
              ignoreValidations={ignoreValidation}
              value={configuracoes.intermediadores.mercadopago?.pix?.ativo || false}
              isValid={() => {
                return (
                  configuracoes.intermediadores.mercadopago?.pix?.ativo &&
                  !configsPix &&
                  !configuracoes.intermediadores.mercadopago?.pix?.percentual_desconto
                    ? false
                    : true
                )
              }}
              invalidText="Preencha as configurações do pix"
              onChange={(newValue) => {
                if (newValue) {
                  // Quando ativar, abre automaticamente as configurações
                  setConfigsPix(true);
                } else {
                  // Quando desativar, fecha as configurações
                  setConfigsPix(false);
                }
                setConfiguracoes(
                  deepCopy(configuracoes, {
                    intermediadores: {
                      mercadopago: {
                        ...configuracoes.intermediadores.mercadopago,
                        pix: {
                          ...configuracoes.intermediadores.mercadopago?.pix,
                          ativo: newValue
                        }
                      }
                    },
                  }),
                );
              }}
              onConfigurar={() => {
                setConfigsPix(!configsPix);
              }}
            />
          </div>

          <Dropdown active={configsPix} className="dropdown">
          <fieldset disabled={somenteLeitura} style={{ border: 0, padding: 0, margin: 0, minWidth: 0, ...(somenteLeitura ? { opacity: 0.6, pointerEvents: "none" } : {}) }}>
            <div className="configsPixContainer">
              <Input
                ignoreValidations={ignoreValidation || !configuracoes.intermediadores.mercadopago?.pix?.ativo}
                type="text"
                required={true}
                value={
                  Number.parseFloat(
                    configuracoes.intermediadores.mercadopago?.pix?.percentual_desconto || "0",
                  ) > 0
                    ? Number.parseFloat(
                        configuracoes.intermediadores.mercadopago?.pix?.percentual_desconto || "0",
                      ).toFixed(0)
                    : "0"
                }
                placeholder="10%"
                mask={{
                  mask: percentageMask,
                  unmask: unmaskPercentage,
                }}
                onChange={(newValue) => {
                  setConfiguracoes(
                    deepCopy(configuracoes, {
                      intermediadores: {
                        mercadopago: {
                          ...configuracoes.intermediadores.mercadopago,
                          pix: {
                            ...configuracoes.intermediadores.mercadopago?.pix,
                            percentual_desconto: newValue
                          }
                        }
                      },
                    }),
                  );
                }}
                label="Porcentagem de desconto"
              />
                  <div className="cancelamentoContainer">
                    <div className="cancelamentoToggle">
                      <Toggle
                        value={!!configuracoes.intermediadores.mercadopago?.pix?.dias_cancelamento}
                        onChange={(ativo) => {
                          if (ativo) {
                            setConfiguracoes(
                              deepCopy(configuracoes, {
                                intermediadores: {
                                  mercadopago: {
                                    ...configuracoes.intermediadores.mercadopago,
                                    pix: {
                                      ...configuracoes.intermediadores.mercadopago?.pix,
                                      dias_cancelamento: "1",
                                      dias_cancelamento_data_ativacao: new Date().toISOString().split('T')[0],
                                    }
                                  }
                                },
                              }),
                            );
                          } else {
                            setConfiguracoes(
                              deepCopy(configuracoes, {
                                intermediadores: {
                                  mercadopago: {
                                    ...configuracoes.intermediadores.mercadopago,
                                    pix: {
                                      ...configuracoes.intermediadores.mercadopago?.pix,
                                      dias_cancelamento: "",
                                      dias_cancelamento_data_ativacao: "",
                                    }
                                  }
                                },
                              }),
                            );
                          }
                        }}
                      />
                      <span className="fonteTexto">Cancelar pedido automaticamente</span>
                    </div>
                    {!!configuracoes.intermediadores.mercadopago?.pix?.dias_cancelamento_data_ativacao && (
                      <>
                        <Input
                          ignoreValidations={true}
                          type="number"
                          required={false}
                          value={configuracoes.intermediadores.mercadopago?.pix?.dias_cancelamento || ""}
                          placeholder="Ex: 3"
                          min={1}
                          max={30}
                          onChange={(newValue) => {
                            let valor = newValue;
                            if (Number(newValue) > 30) valor = "30";
                            if (Number(newValue) < 1) valor = "1";
                            setConfiguracoes(
                              deepCopy(configuracoes, {
                                intermediadores: {
                                  mercadopago: {
                                    ...configuracoes.intermediadores.mercadopago,
                                    pix: {
                                      ...configuracoes.intermediadores.mercadopago?.pix,
                                      dias_cancelamento: valor
                                    }
                                  }
                                },
                              }),
                            );
                          }}
                          label="Prazo limite para pagamento (dias)"
                        />
                        <span className="cancelamentoInfo">
                          Ativo desde {new Date(configuracoes.intermediadores.mercadopago?.pix?.dias_cancelamento_data_ativacao + 'T00:00:00').toLocaleDateString('pt-BR')}. Apenas pedidos realizados a partir desta data serão cancelados automaticamente.
                        </span>
                      </>
                    )}
                  </div>
            </div>
          </fieldset>
          </Dropdown>
        </div>
          </>
        )}
      </PagamentoMercadoPagoContainer>

      <Modal
        width={"80rem"}
        maxWidth="98vw"
        isOpen={modal}
        backdrop={"static"}
        setModal={setModal}
      >
        <ModalContainer theme={theme}>
          <div className="titulo fonteTitulo">Autorização Mercado Pago</div>
          <div className="texto fonteTexto">
            O Mercado Pago é uma solução de pagamentos que possibilita que seus clientes finalizem pedidos utilizando PIX, cartão de crédito e outras formas de pagamento de forma prática e confiável. <br />
            Para ativar essa integração, você precisa ter uma conta ativa no Mercado Pago e realizar a autorização da mesma na plataforma.<br /><br />
            <strong>Recomendamos que a configuração seja feita através de um computador para garantir uma melhor experiência.</strong>
          </div>
          <div className="botoes fonteTexto">
            <div className="cancelar" onClick={handleCancelarAutenticacao}>
              Cancelar
            </div>
            <Button title="Autorizar no Mercado Pago" onClick={abrirLogin} />
          </div>
        </ModalContainer>
      </Modal>
    </>
  );
};

export default PagamentoMercadoPago;
